import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CancelButton, DBDropDown, DBTextField, DBCheckBox, RedoButton } from '_components';
import styles from './Common.module.css';


class AlManualRow extends React.Component {

    remove() {
        this.props.removeChildRow(this.props.noteId, 'MLMANUAL', 'XLMA', this.props.manual.XLMANO);
    }

    handlePerformed(val) {
        if (!this.props.onAssessment && val === true) {
            this.props.updateBitField(this.props.noteId, 'PTPLAN', 'PLNO', this.props.plno, 'PLMANUAL', true);
        }
        if (this.props.computedChargesVisible) {
            this.props.hideComputedCharges({ noteId: this.props.noteId });
        }
    }

    render() {
        return (
            <span>
                <div className={this.props.manual.XLMAPERFORMED ? styles.row_performed : styles.row}>
                    <div className={styles.remove_button}>
                        <CancelButton title='Remove' size='extra-small' onClick={() => this.remove()} />
                    </div>
                    <DBDropDown
                        field='XLMAMANO'
                        noteId={this.props.noteId}
                        entity='MLMANUAL'
                        entityKeyColumn='XLMANO'
                        entityKeyValue={this.props.manual.XLMANO}
                        className={this.props.manual.XLMAPERFORMED && !this.props.manual.XLMAMANO ? styles.col1_performed : styles.col1}
                        customOptions={this.props.activities}
                    />
                    <DBTextField
                        noteId={this.props.noteId}
                        entity='MLMANUAL'
                        entityKeyColumn='XLMANO'
                        entityKeyValue={this.props.manual.XLMANO}
                        field='XLMAACTIVITY'
                        className={this.props.manual.XLMAPERFORMED && !this.props.manual.XLMAACTIVITY ? styles.col2_performed : styles.col2}
                    />
                    <DBTextField
                        noteId={this.props.noteId}
                        entity='MLMANUAL'
                        entityKeyColumn='XLMANO'
                        entityKeyValue={this.props.manual.XLMANO}
                        field='XLMASETSREPS'
                        className={this.props.manual.XLMAPERFORMED && !this.props.manual.XLMASETSREPS ? styles.col3_performed : styles.col3}
                    />
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='MLMANUAL'
                        entityKeyColumn='XLMANO'
                        entityKeyValue={this.props.manual.XLMANO}
                        field='XLMAPERFORMED'
                        className={styles.col4}
                        disabled={this.props.performedDisabled}
                        onClick={(val) => this.handlePerformed(val)}
                    />
                    <span className={styles.col5} />
                    {this.props.prevVisit &&
                        <span className={styles.col6}>
                            <RedoButton size='extra-small' title='Performed during previous visit' />
                        </span>
                    }
                </div>
            </span>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        removeChildRow: bindActionCreators(noteActions.removeChildRow, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        clearFields: bindActionCreators(noteActions.clearFields, dispatch),
        hideComputedCharges: bindActionCreators(noteActions.hideComputedCharges, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let xlno = parseInt(Object.keys(state.entities.notes.MLEXLOG)
        .find(key => (state.entities.notes.MLEXLOG[key].XLEVNO === pk && noteType === 1)
            || (state.entities.notes.MLEXLOG[key].XLNTNO === pk && noteType !== 1)));
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isPeds = state.entities.admissions[epno].isPeds;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_PEDS_ENABLED'].PRVALUE === 'true' : false;
    let isFederal = state.entities.admissions[epno].isFederal;
    let isWc = state.entities.admissions[epno].isWc;
    let isAuto = state.entities.admissions[epno].isAuto;
    let isOther = (isPedsEnabled && !isPeds && !isFederal && !isWc && !isAuto) || (!isPedsEnabled && !isFederal && !isWc && !isAuto) ? true : false;
    let manual = state.entities.notes.MLMANUAL[ownprops.id];
    let prevVisit = Object.keys(state.entities.notes.MLMANUALPREV)
        .find(key => (state.entities.notes.MLMANUALPREV[key].NoteId === noteId &&
            state.entities.notes.MLMANUALPREV[key].XLMAMANO === manual.XLMAMANO &&
            state.entities.notes.MLMANUALPREV[key].XLMAACTIVITY === manual.XLMAACTIVITY
        )) !== undefined ? true : false;
    let plno = parseInt(Object.keys(state.entities.notes.PTPLAN)
        .find(key => (state.entities.notes.PTPLAN[key].PLEVNO === pk && noteType === 1)
            || (state.entities.notes.PTPLAN[key].PLNTNO === pk && noteType !== 1)));
    let onAssessment = state.entities.notes.PTPLAN[plno] && state.entities.notes.PTPLAN[plno].PLMANUAL ? true : false;
    let computedChargesVisible = state.ui.notes[noteId].computedChargesVisible;

    let activities = state.entities.masterData.MLMASTERMANUAL ?
        Object.keys(state.entities.masterData.MLMASTERMANUAL)
            .filter(key => {
                if ((isPedsEnabled && isPeds && state.entities.masterData.MLMASTERMANUAL[key].MAPEDS) ||
                    (isFederal && state.entities.masterData.MLMASTERMANUAL[key].MAMC) ||
                    (isWc && state.entities.masterData.MLMASTERMANUAL[key].MAWC) ||
                    (isAuto && state.entities.masterData.MLMASTERMANUAL[key].MAAUTO) ||
                    (isOther && state.entities.masterData.MLMASTERMANUAL[key].MAOTHER)) {
                    return true;
                } else {
                    return false;
                }
            })
            .sort((a, b) => state.entities.masterData.MLMASTERMANUAL[a].MANAME.localeCompare(state.entities.masterData.MLMASTERMANUAL[b].MANAME))
            .map(key => (
                {
                    id: state.entities.masterData.MLMASTERMANUAL[key].MANO,
                    value: state.entities.masterData.MLMASTERMANUAL[key].MANAME
                }
            )) : [];
    let performedDisabled = noteType === 3 || noteType === 4 ? true : false;

    return {
        noteId: noteId,
        xlno: xlno,
        manual: manual,
        activities: activities,
        prevVisit: prevVisit,
        plno,
        onAssessment,
        computedChargesVisible,
        performedDisabled
    };
}

const connectedAlManualRow = connect(mapStateToProps, mapDispatchToProps)(AlManualRow);
export { connectedAlManualRow as AlManualRow };

